module.exports = __webpack_public_path__ + "static/media/coupon.06268569.svg";